export default "__VITE_ASSET__JJdM_qCU__"